/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Error_FetchingInputs */

const en_profile_error_fetching = /** @type {(inputs: Profile_Error_FetchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error fetching profile`)
};

const es_profile_error_fetching = /** @type {(inputs: Profile_Error_FetchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al obtener el perfil`)
};

/**
* | output |
* | --- |
* | "Error fetching profile" |
*
* @param {Profile_Error_FetchingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const profile_error_fetching = /** @type {((inputs?: Profile_Error_FetchingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Error_FetchingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_profile_error_fetching(inputs)
	return en_profile_error_fetching(inputs)
});